<template>
  <div class="d-flex justify-space-between mb-4">
    <div class="d-flex">
      <div>
        <AppSearchInput
          class="width-320"
          @search="filterElements({ query: $event })"
        />
      </div>

      <v-select
        v-if="archive"
        :items="years"
        placeholder="Wybierz rok"
        background-color="white"
        color="primary"
        class="ml-2 width-160"
        clearable
        v-bind="staticData.props.select"
        @input="filterByDate"
      >
        <template #prepend-inner>
          <v-icon
            small
            class="mr-2"
          >
            mdi-calendar-month
          </v-icon>
        </template>
      </v-select>

      <v-menu
        v-else
        ref="datePicker"
        v-model="isDatePickerShown"
        :close-on-content-click="false"
        class="width-140"
        transition="scale-transition"
        offset-y
        z-index="11"
        max-width="290"
        min-width="290"
      >
        <template #activator="{ on, attrs }">
          <div v-on="on">
            <v-text-field
              :value="dateFormatted"
              persistent-hint
              v-bind="{...attrs, ...staticData.props.shortTextField}"
              readonly
              hide-details
              clearable
              color="primary"
              placeholder="Data rozpoczęcia"
              class="input-calendar ml-2"
              append-icon="mdi-calendar-month-outline"
              @click:clear="filterElements({ daterange: [] })"
            />
          </div>
        </template>

        <v-date-picker
          v-model="date"
          v-bind="staticData.props.datePicker"
          range
          :title-date-format="() => dateFormatted"
          @change="filterElements({ daterange: $event.sort() })"
          @input="isDatePickerShown = false"
        />
      </v-menu>

      <v-btn
        class="ml-3"
        outlined
        @click="exportProjectsData"
      >
        Eksport
      </v-btn>
    </div>
    <div class="d-flex align-center">
      <AppViewToggle
        v-model="currentView"
        class="mr-7"
      />

      <v-menu
        v-if="!archive"
        bottom
        left
        offset-y
      >
        <template #activator="{ on, attrs }">
          <div class="d-flex align-center">
            <span class="caption">
              Sortuj po
            </span>

            <v-btn
              icon
              small
              v-bind="attrs"
              class="ml-1 pa-1"
              v-on="on"
            >
              <v-img
                v-if="order.length"
                src="/icons/icon_sort_on.svg"
                height="20"
                max-width="20"
                cover
              />

              <v-img
                v-else
                src="/icons/icon_sort_off.svg"
                height="20"
                max-width="20"
                cover
              />
            </v-btn>
          </div>
        </template>

        <v-list min-width="160">
          <v-list-item
            v-for="option in staticData.sortOptions"
            :key="option.value"
            dense
            @click="sortElements(order === option.value ? '' : option.value)"
          >
            <v-list-item-title :class="{'font-weight-bold' : option.value === order}">
              {{ option.label }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import AppSearchInput from '@/components/UI/AppSearchInput.vue';
import AppViewToggle from '@/components/UI/AppViewToggle.vue';
import sortOptions from '@/helpers/sortOptions';
import props from '@/helpers/componentsProps';
import utils from '@/helpers/utils';
import dayjs from 'dayjs';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    AppSearchInput,
    AppViewToggle,
  },

  props: {
    archive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      date: [],
      isDatePickerShown: false,
      staticData: {
        sortOptions,
        props,
      },
    };
  },

  computed: {
    ...mapState('filters', [
      'order',
    ]),

    ...mapState('projects', [
      'viewMode',
    ]),

    years() {
      const start = new Date().getFullYear();
      const end = 2020;
      // make array with years from current to 2020 (PTM start)
      return new Array(start - end + 1).fill().map((_, i) => (start - i).toString());
    },

    currentView: {
      get() {
        return this.viewMode;
      },
      set(view) {
        this.setViewMode(view);
      },
    },

    dateFormatted() {
      return this.archive
      ? this.date.map((d) => dayjs(d).format('MM.YYYY')).join(' - ')
      : utils.formatDateOutput(this.date);
    },
  },

  methods: {
    ...mapActions('filters', [
      'setFilters',
      'setSorting',
    ]),

    ...mapActions('projects', [
      'setViewMode',
      'exportProjectsData',
    ]),

    filterByDate(year) {
      let daterange = [];
      if (year) {
        const day = dayjs(new Date(year));
        daterange = [day.startOf('year'), day.endOf('year')]
          .map((date) => date.format('YYYY-MM-DD'));
      }

      this.filterElements({ daterange });
    },

    filterElements(filterObject) {
      this.setFilters(filterObject)
        .then(() => {
          this.$emit('search');
        });
    },

    sortElements(sortingOption) {
      this.setSorting(sortingOption)
        .then(() => {
          this.$emit('search');
        });
    },
  },
};
</script>
